import { useMutation } from "@tanstack/react-query";
import { SUBMIT_INSCRIPCION } from "./endpoints";
import { postRequest, deleteRequest, putRequest } from "./axiosClient";

export const useSubmitInscripcion = () => {
	return useMutation({
		mutationFn: ({ inscripcionData, tokenSeguridad }) => {
			return postRequest(
				`${SUBMIT_INSCRIPCION}?tks=${tokenSeguridad}`,
				inscripcionData
			);
		},
	});
};

export const useApproveInscripcion = () => {
	return useMutation({
		mutationFn: ({ inscripcionData, tokenSeguridad }) => {
			return putRequest(
				`${SUBMIT_INSCRIPCION}?tks=${tokenSeguridad}`,
				inscripcionData
			);
		},
	});
};

export const useCorrectInscripcion = () => {
	return useMutation({
		mutationFn: ({ inscripcionData, tokenSeguridad }) => {
			return postRequest(
				`${SUBMIT_INSCRIPCION}?tks=${tokenSeguridad}`,
				inscripcionData
			);
		},
	});
};

export const useDeleteSubscription = () => {
	return useMutation({
		mutationFn: ({ inscripcionData, tokenSeguridad }) => {
			return deleteRequest(
				`${SUBMIT_INSCRIPCION}?tks=${tokenSeguridad}`,
				inscripcionData
			);
		},
	});
};
